import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "24",
  viewBox: "0 0 28 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M27.223 5.06547C26.9931 4.86086 26.7132 4.72172 26.4123 4.66245C26.1114 4.60318 25.8001 4.62592 25.5114 4.72832L23.9932 5.4571C21.9302 6.42875 19.4744 5.60937 18.4304 3.60629L17.2919 1.4185C17.1466 1.14471 16.9331 0.919 16.6737 0.759398C16.4144 0.599796 16.1187 0.512329 15.8161 0.506592C15.5136 0.500856 15.2149 0.577073 14.9502 0.72667C14.6855 0.876267 14.4643 1.09461 14.3096 1.36145L13.1712 3.5493C12.1272 5.55238 9.67139 6.37176 7.60836 5.40011L6.0902 4.67133C5.79949 4.55271 5.48141 4.5209 5.17361 4.57923C4.86582 4.63756 4.58012 4.7841 4.34943 5.00105C4.11875 5.21801 3.95314 5.49625 3.87232 5.80289C3.7915 6.10953 3.79891 6.43231 3.89369 6.7351L6.4881 18.8091C6.53981 19.0407 6.63498 19.2603 6.76911 19.4553C6.90325 19.6502 7.07393 19.8172 7.27153 19.9464C7.53075 20.1147 7.83261 20.2044 8.14066 20.2048C8.28942 20.2045 8.43747 20.183 8.58079 20.1408C13.3607 18.7414 18.4506 18.7414 23.2305 20.1408C23.6612 20.2609 24.1223 20.1943 24.5045 19.9464C24.6996 19.8288 24.8659 19.6684 24.9986 19.4783C25.1313 19.2883 25.2276 19.0725 25.2825 18.8091L27.8845 6.7351C27.9515 6.40808 27.9358 6.06877 27.8391 5.75035C27.7423 5.43192 27.5675 5.14588 27.223 5.06547Z",
  fill: "#F0C419"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }